import auth from '../apis/auth.api';
import { authApi } from '../apis';
import { authorizerTokenCookie } from '../types';
import cookies from 'browser-cookies';
export const userStartEmulation = async (email) => {
    return await authApi.post('autodesk/user/emulation', {
        email,
        token: cookies.get(authorizerTokenCookie),
    });
};
export const userEndEmulation = async () => {
    return auth.post('autodesk/user/emulation', {
        token: cookies.get(authorizerTokenCookie),
    });
};
